export const parseQueryString = (qs) => {
  const query = {};
  const pairs = (qs[0] === "?" ? qs.substr(1) : qs).split("&");
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
};
